module.exports = __webpack_public_path__ + "img/0-3.e907c24a.gif";